export class Delegate {
    public delegatedTo: string;
    public delegatedFrom: string;
    public delegatedToDate: string;
    public delegatedFromDate: string;
    public userObj: object;
    public delegateFromName: string;
    constructor(d: any = {}) {
        this.delegatedTo = d.delegatedTo || '';
        this.delegatedFrom = d.delegatedFrom || '';
        this.delegatedFromDate = d.delegatedFromDate || '';
        this.delegatedToDate = d.delegatedToDate || '';
        this.delegateFromName = d.delegateFromName || '';
    }
}
export class EditDelegate {
    public delegationID: string;
    public updateItems: Delegate;
    constructor(d: any = {}) {
        this.delegationID = d.delegationID || '';
        this.updateItems = d.updateItems || new Delegate({});
    }
}


// WEBPACK FOOTER //
// ./src/app/rm/deligate/add-deligate/deligate.ts